module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel9-5db08e4f73d9c52691529fc33da7873d.jpg";